import { formatDisplayDatesForSearch } from "../../../services/Utils";
import { Tooltip, useTheme } from "@mui/material";

export function ValueChicklet({
  index,
  searchVal,
  operator,
  onItemEdited,
  mode,
}) {
  const theme = useTheme();
  let text;
  let searchValLength;
  let fullList;
  if (searchVal) {
    searchValLength = searchVal?.length;
    if (operator?.id === "between") {
      text = formatDisplayDatesForSearch(searchVal?.value);
    } else if (searchValLength > 0) {
      if (searchValLength > 1) {
        text = searchVal[0]?.value;
        fullList = searchVal.map((o) => o.value).join(", ");
      } else {
        text = searchVal[0].value;
      }
    } else {
      text = searchVal?.value;
    }
  }
  if (!!text) {
    return (
      <div
        className="searchvalue valueContainer"
        onClick={() => {
          // event.stopPropagation();
          if (mode !== "editValue" && mode !== "value") onItemEdited(index);
        }}
        style={{ fontSize: "small", textOverflow: "ellipsis" }}
      >
        {searchValLength > 1 ? (
          <div
            style={{
              position: "relative",
              display: "inline-block",
            }}
          >
            <div style={{ paddingRight: "26px" }}>{text}</div>
            <Tooltip title={`Items : ${fullList}`} arrow>
              <div
                style={{
                  position: "absolute",
                  right: -1.5,
                  top: 0,
                  backgroundColor: theme.palette.secondary.dark,
                  color: "white",
                  borderRadius: "4px",
                  padding: "0 2px",
                  fontSize: "0.75rem",
                  minWidth: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {`+${searchValLength - 1}`}
              </div>
            </Tooltip>
          </div>
        ) : (
          <div>{text}</div>
        )}
      </div>
    );
  }
}
